import { render } from "./BaseCard.vue?vue&type=template&id=55eecb03&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=55eecb03&scoped=true&lang=css"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55eecb03"]])

export default __exports__